module.exports = __webpack_public_path__ + "static/img/clickin3.111bdbd5.png";